<template>
  <div>
    <v-container class="pa-5">
      <h1 class="display-3 pa-5 indigo darken-1 white--text rounded-tl-xl">
        Fidelidade
      </h1>

      <v-divider></v-divider>
      <v-form ref="form" v-model="valid" class="pa-5" @submit.prevent="buscarCliente()">
        <v-row>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="termoQuery"
              prepend-inner-icon="mdi-magnify"
              label="Pequise por nome"
              :rules="inputRules"
              required
              @keydown.enter="buscarCliente()"
            >
            </v-text-field>
          </v-col>
          <v-col cols="5" sm="2">
            <v-text-field
              :rules="inputRules"
              label="Data inicial"
              type="date"
              v-model="dataIni"
              required
            >
            </v-text-field>
          </v-col>
          <v-col cols="5" sm="2">
            <v-text-field
              :rules="inputRules"
              label="Data final"
              type="date"
              v-model="dataFim"
              required
            >
            </v-text-field>
          </v-col>
          <v-col cols="3" sm="2">
            <v-btn
              fab
              class="green"
              @click="buscarCliente()"
              :disabled="!valid"
            >
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
            <!-- <v-btn
              fab
              dark
              class="green"
              @click="converterAgendamentos()"
              
            >
              <v-icon>mdi-magnify</v-icon>
            </v-btn> -->
          </v-col>
        </v-row>
      </v-form>
      <p class="grey--text">
        *Resultados de no máximo 40 consultas/visitas (banco de dados possui
        limite gratuito de pesquisas)
      </p>
      <br />

      <v-row v-if="listaFidelidade.length > 0">
        <v-col
          cols="12"
          md="6"
          lg="4"
          v-for="item in listaFidelidade"
          :key="item.email"
        >
          <v-card class="mx-auto loyalty-card" dark color="indigo darken-4">
            <v-list-item three-line>
              <v-list-item-content>
                <div class="overline mb-4">CARTÃO FIDELIDADE</div>
                <v-list-item-title class="headline mb-1">
                  {{ item.nome }}
                </v-list-item-title>
                <v-list-item-subtitle>{{ item.email }}</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-avatar tile size="80" color="transparent">
                <v-icon size="60" color="amber">mdi-crown</v-icon>
              </v-list-item-avatar>
            </v-list-item>

            <v-card-text class="py-0">
       
              <div class="text-center mt-3 caption">
                {{ item.totalVisitas }} visitas registradas no total
              </div>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <CartaoFidelidade :item="item" />
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// import FeriadoDialog from './Components/FeriadoDialog'
import CartaoFidelidade from './Components/CartaoFidelidade'

import { refAgenda } from "@/firebaseConfig";

export default {
  components: {
    CartaoFidelidade
  },
  data() {
    const dataAtual = new Date();
    const hoje = dataAtual.toISOString().substr(0, 10);
    const anoPassado = dataAtual.getFullYear() - 1;
    const primeiroDiaAnoPassado = `${anoPassado}-01-01`;
    return {
      termoQuery: "",
      // refFeriados: refFeriados,
      listaBuscados: [],
      listaFidelidade: [],
      dataIni: primeiroDiaAnoPassado,
      dataFim: hoje,
      dialog: false,
      valid: true,
      inputRules: [
        (v) => !!v || "Este campo é obrigatório",
        (v) =>
          (v && v.length >= 3) || "Nome precisa ter pelo menos 3 caracteres",
      ],
    };
  },
  methods: {
    async buscarCliente() {
      this.listaFidelidade = []
      this.listaBuscados = []
      let queryText = this.termoQuery
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      // .where('name', '>=', queryText).where('name', '<=', queryText+ '\uf8ff'
      console.log(this.dataIni);
      console.log(this.dataFim);
      let dataIni = new Date(this.dataIni + "T00:00-03:00").getTime();
      let dataFim = new Date(this.dataFim + "T00:00-03:00").getTime();
      console.log(dataIni);
      console.log(dataFim);

      await refAgenda
        .where("searchTermsArray", "array-contains", queryText.toLowerCase())
        // .orderBy("email")
        .where("dataQuery", ">=", dataIni)
        .where("dataQuery", "<=", dataFim)
        .limit(40)
        .get()
        .then((ref) => {
          ref.forEach((usuario) => {
            // console.log(produto.data().nome);
            this.listaBuscados.push(usuario.data());
          });
        });
        //AGRUPAR POR EMAIL
      for (const agendamento of this.listaBuscados) {
        this.agruparPorEmail(agendamento);
      }
        //REMOVER DUPLICADOS E ORDENAR POR VISITAS (MAIOR PARA MENOR)
        this.listaFidelidade = this.removeDuplicates("email").sort(
          (a, b) => b.totalVisitas - a.totalVisitas
        );
        console.log(this.listaFidelidade);
    },
    agruparPorEmail(agendamento) {
      let contadorPresenca = 0;
      for (const agendamentoQuery of this.listaBuscados) {
        if (agendamento.cliente.email == agendamentoQuery.cliente.email) {
          contadorPresenca = contadorPresenca + 1;
        }
      }
      this.listaFidelidade.push({
        nome: agendamento.cliente.nome,
        email: agendamento.cliente.email,
        totalVisitas: contadorPresenca,
      });
    },
    removeDuplicates(prop) {
      var newArray = [];
      var lookupObject = {};

      for (var i in this.listaFidelidade) {
        lookupObject[this.listaFidelidade[i][prop]] = this.listaFidelidade[i];
      }

      for (i in lookupObject) {
        newArray.push(lookupObject[i]);
      }
      return newArray;
    },
    visualizarCartao(item) {
      console.log(item);
      alert("Abrir Dialog");
    },
    async converterAgendamentos(){
      let dataIni = new Date(this.dataIni).getTime();
      let dataFim = new Date(this.dataFim).getTime();

       await refAgenda
        .where("dataQuery", ">=", dataIni)
        .where("dataQuery", "<=", dataFim)
        .limit(1000)
        .get()
        .then((ref) => {
          ref.forEach((usuario) => {
            // console.log(produto.data().nome);
            let agendamento = usuario.data();
            console.log(usuario);
            if(agendamento.cliente.nome){

              agendamento.searchTermsArray = this.gerarTermosParaPesquisa(agendamento.cliente.nome);
              refAgenda.doc(usuario.id).update(agendamento)
              // usuario.ref().update(agendamento);
            }
            console.log(agendamento);
          });
        });
    },
    gerarTermosParaPesquisa(nome){
            //gerar termos para pesquisa
            let searchTermsArray = nome.split(" ")
            searchTermsArray = searchTermsArray.map(term => {
              term = term.toLowerCase();
              term = term.normalize('NFD').replace(/[\u0300-\u036f]/g, "");

              return term
            });

            return searchTermsArray;
        }

  },
  created() {
    // this.carregarLista();
  },
};
</script>

<style lang="scss" scoped>
.loyalty-card {
  border: 2px solid #ffca28 !important; // Borda dourada/amber
  border-radius: 15px !important;
  background: linear-gradient(135deg, #1a237e 0%, #311b92 100%) !important;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3) !important;
}

.stamps-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  padding: 15px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
}

.stamp-slot {
  width: 100%;
  aspect-ratio: 1;
  border: 2px dashed rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  transition: all 0.3s ease;

  &.filled {
    border: 2px solid #00e676;
    background: rgba(0, 230, 118, 0.2);
    box-shadow: 0 0 10px rgba(0, 230, 118, 0.4);
  }
}
</style>
